import React, { createRef } from 'react';

import { TypeLegislation } from '../../types/menu-legislation';
import styles from './tabs.module.scss';
import './../../theme/global.scss';

interface ITabs {
  options: TypeLegislation[];
  currentOption: TypeLegislation;
  onChange: (v: TypeLegislation) => void;
}

const Tabs = (props: ITabs) => {
  const currentTab: React.RefObject<HTMLInputElement> = createRef();

  const handleClick = (v: TypeLegislation) => {
    if (currentTab && currentTab.current) {
      if (
        props.options.indexOf(props.currentOption) > props.options.indexOf(v)
      ) {
        currentTab.current.scrollLeft += -150;
      } else currentTab.current.scrollLeft += 150;
    }

    props.onChange(v);
  };

  return (
    <div className={styles.tabMenu}>
      <div className={styles.tabs} ref={currentTab}>
        {props.options.length > 0 &&
          props.options.map((option: TypeLegislation) =>
            props.currentOption === option ? (
              <div
                className={styles.currentTab}
                key={option.key}
                onClick={() => handleClick(option)}
              >
                <p className='body-dark'>{option.name}</p>
              </div>
            ) : (
              <div
                className={styles.tab}
                key={option.key}
                onClick={() => handleClick(option)}
              >
                <p className='body-dark'>{option.name}</p>
              </div>
            )
          )}
      </div>
    </div>
  );
};

export default Tabs;
